import { defineComponent as _defineComponent } from 'vue'
import {
  TUIGlobal,
  TUIStore,
  StoreName,
  TUITranslateService,
  TUIGroupService,
  IConversationModel
} from "@tencentcloud/chat-uikit-engine";
import { ref, defineEmits } from "../../../adapter-vue";
import Icon from "../../common/Icon.vue";
import backSVG from "../../../assets/icon/back.svg";
import settingSVG from "../../../assets/icon/setting.svg";
import ManageGroup from "../../TUIGroup/manage-group/index.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["closeChat"],
  setup(__props, { emit: emits }) {


const isPC = ref(TUIGlobal.getPlatform() === "pc");
const currentConversation = ref<IConversationModel>();
const currentConversationName = ref("");
const typingStatus = ref(false);
const isGroup = ref(false);
const groupID = ref('');
const conversationType = ref('GROUP');
const showGroupDialog = ref(false);
const groupCurrentTab = ref('');

TUIStore.watch(StoreName.CONV, {
  currentConversation: (conversation: IConversationModel) => {
    currentConversation.value = conversation;
    isGroup.value = currentConversation.value?.type === conversationType.value;
    if(groupID.value !== currentConversation.value?.groupProfile?.groupID) {
      showGroupDialog.value = false;
      // 清空对应群组信息
      TUIGroupService.switchGroup();
    }
    groupID.value = currentConversation.value?.groupProfile?.groupID;
    currentConversationName.value = currentConversation?.value?.getShowName();
  },
});
TUIStore.watch(StoreName.CHAT, {
  typingStatus: (status: boolean) => {
    typingStatus.value = status;
    switch (typingStatus.value) {
      case true:
        currentConversationName.value =
          TUITranslateService.t("TUIChat.对方正在输入");
        break;
      case false:
        currentConversationName.value = currentConversation?.value?.getShowName();
        break;
    }
  },
});

const closeChat = (conversationID: string) => {
  emits("closeChat", conversationID);
};

const showGroupDetails = () => {
  showGroupDialog.value = !showGroupDialog.value;
  if (!showGroupDialog.value) {
    groupCurrentTab.value = '';
    TUIGroupService.switchGroup();
  }
  if (showGroupDialog.value) {
    TUIGroupService.switchGroup(groupID.value);
  }
};


return { __sfc: true,emits, isPC, currentConversation, currentConversationName, typingStatus, isGroup, groupID, conversationType, showGroupDialog, groupCurrentTab, closeChat, showGroupDetails, Icon, backSVG, settingSVG, ManageGroup }
}

})